import $ from "cash-dom";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import getCssVarValue from "./function_get-css-var-value";

export default (function () {
    var selector = ".swiper";

    function init() {
        if (!$(selector).length) return;

        jdmn.log("function_slider.js initialized", "green");

        var indent = getCssVarValue("--space-global");

        $(selector).each(function () {
            var $instance = $(this);
            /*
            var autoplay;
            var autoplayDuration = 3200;
            var userHasClicked = false;
            var indent =
                getCssVarValue("--space-global") + getCssVarValue("--space-column") + getCssVarValue("--width-column");
            */

            new Swiper($instance[0], {
                centeredSlides: true,
                spaceBetween: getCssVarValue("--space-column"),
                // slidesOffsetBefore: indent,
                // slidesOffsetAfter: indent,
                slidesPerView: "auto",
                speed: getCssVarValue("--duration-md"),
                // autoHeight: true,
                modules: [Navigation, Pagination],
                // loop: false,
                allowTouchMove: true,
                disabledClas: "pointer-none",
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: "[data-next]",
                    prevEl: "[data-prev]",
                },
                on: {
                    slideChange: slideChangeHandler,
                },
            });

            $instance.attr("data-initial", $instance[0].swiper.translate);

            /*
            $instance
                .parents(".layout")
                .find("[data-description]")
                .each(function (_i, _el) {
                    var $clone = $(this).clone();

                    $clone.removeClass("hide").addClass("fade-in transition-md");
                    if (_i == 0) $clone.addClass("on");

                    $instance.parents(".layout").find(".description-wrapper").append($clone);
                });
            */
        });

        $(selector)
            .find("[data-description] [data-toggle]")
            .on("click", function () {
                var $button = $(this);
                var $slide = $button.parents(".swiper-slide");
                var slideIndex = $slide.index();
                var slideWidth = $slide.width();
                var $instance = $slide.parents(".swiper");
                var swiper = $instance[0].swiper;
                var $content = $slide.find("[data-description-content]");
                var contentWidth = $content[0].clientWidth;

                contentWidth = window.innerWidth < 600 ? contentWidth + indent : contentWidth;
                // var initialTranslate = $(swiper).attr("data-initial");
                var currentTranslate = swiper.translate;
                var offset = $content.hasClass("on")
                    ? currentTranslate + contentWidth
                    : currentTranslate - contentWidth;
                var resize = $content.hasClass("on") ? slideWidth - contentWidth : slideWidth + contentWidth;
                var speed = getCssVarValue("--duration-md");

                $button.toggleClass("bg-lighten bg-white");
                $button.find("span").toggleClass("on");
                $content.toggleClass("on alpha-0");

                $slide.css("width", resize);
                swiper.update();

                setTimeout(function () {
                    $content.toggleClass("-z-1");
                    if (slideIndex == 0 && !$content.hasClass("on")) {
                        swiper.slideTo(0);
                    } else {
                        swiper.setTranslate(offset);
                    }
                }, speed);
            });
    }

    function slideChangeHandler(_Swiper) {
        var $instance = $(_Swiper.el);

        $instance.parents(".layout").find(".description-wrapper .description").removeClass("on");
        $instance.parents(".layout").find(".description-wrapper .description").eq(_Swiper.activeIndex).addClass("on");
    }

    $(document).ready(init);
})();
